import { Component, signal } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'hx-header',
  standalone: true,
  imports: [RouterLink, RouterLinkActive, MatButtonModule],
  template: `
    <nav class="nav">
      <div class="wrap">
        <a routerLink="/" class="brand">
          <img
            src="assets/images/logo.png"
            height="40px"
            alt="Hexacorp Logo"
            class="brand-logo"
          />
          <!-- <span>Hexacorp</span> -->
        </a>

        <div class="nav-links" [class.nav-links-open]="open()">
          <a href="/#solutions" (click)="closeMenu()">Solutions</a>
          <a href="/#work" (click)="closeMenu()">Work</a>
          <a href="/#process" (click)="closeMenu()">Process</a>
          <a routerLink="/promotions" routerLinkActive="active" (click)="closeMenu()">Promotions</a>
          <a href="/#contact" (click)="closeMenu()">Contact</a>
        </div>

        <div class="nav-cta">
          <a href="/#contact" mat-flat-button class="btn btn-primary btn-sm">
            Start a project
          </a>
          <button
            class="nav-toggle"
            type="button"
            aria-label="Toggle menu"
            [attr.aria-expanded]="open()"
            (click)="toggle()"
          >
            <span></span><span></span><span></span>
          </button>
        </div>
      </div>
    </nav>
  `,
})
export class HeaderComponent {
  open = signal(false);

  toggle(): void {
    this.open.update((v) => !v);
  }

  closeMenu(): void {
    this.open.set(false);
  }
}
